export function initMastheadParallax() {
    const masthead = document.querySelector('.gh-masthead');
    if (!masthead) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;

    const update = () => {
        const y = window.scrollY;
        const opacity = Math.max(0, 1 - y / 500);
        const scale = 1 - Math.min(0.04, y / 20000);
        masthead.style.setProperty('--scroll-y', y);
        masthead.style.setProperty('--scroll-opacity', opacity.toFixed(3));
        masthead.style.setProperty('--scroll-scale', scale.toFixed(3));
        masthead.style.setProperty('--scroll-offset', `${-y * 0.1}px`);
        ticking = false;
    };

    const onScroll = () => {
        if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
        }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
}
